var Vote = function() {
    return {
        // Mainly for testing purposes
        timesAddShown: 0,
        // For each group, only ONE vote can be stored
        voteGroups: {
            '1': 1, '2': 1, 'X': 1, 'H': 1, 'B': 1, 'A': 1,
            'O': 2, 'U': 2, 'Q': 2, 'W': 2, 'E': 2, 'R': 2,
            '3': 3, '4': 3, '5': 3,
            'N': 4, 'G': 4
        },
        stringifyVotes: vote => `${ vote }`,
        showCookieVotes: () => {
            let votes = {};
            if (Generic.jsCookies.hasItem('userVotes')) {
                votes = Generic.jsCookies.getItem('userVotes');
                votes = decodeURIComponent(votes);
                votes = JSON.parse(atob(votes));
            }

            for (var matchId in votes) {
                votes[matchId].forEach((vote) => {
                    $('#bvote' + vote + matchId).removeClass('btn-light').addClass('btn-primary');
                });
            }
        },
        getCookieVotes: () => {
            let votes = {};
            if (Generic.jsCookies.hasItem('userVotes')) {
                votes = Generic.jsCookies.getItem('userVotes');
                votes = decodeURIComponent(votes);
                votes = JSON.parse(atob(votes));
            }

            return votes;
        },
        setCookieVotes: (cookieVotes) => {
            cookieVotes = Generic.sliceObject(cookieVotes, 50);
            cookieVotes = btoa(JSON.stringify(cookieVotes));
            cookieVotes = encodeURIComponent(cookieVotes);
            Generic.jsCookies.setItem('userVotes', cookieVotes, 3600 * 12, '/'); // 12 hours
            return cookieVotes;
        },
        updateCookieVoteCount: () => {
            const voteCount = Generic.jsCookies.hasItem('VOTECOUNT') ?
                (parseInt(Generic.jsCookies.getItem('VOTECOUNT')) * 1 + 1) : 1;

            Generic.jsCookies.setItem('VOTECOUNT', voteCount, 3600 * 24 * 90, '/');
            return voteCount;
        },
        // Removes all votes for the given group
        clearVotes: (matchVotesArr, voteGroup = 1) => {
            const clearedVotes = [];
            matchVotesArr.forEach((vote) => {
                if (voteGroup !== Vote.voteGroups[vote]) {
                    clearedVotes.push(vote);
                }
            });
            return clearedVotes;
        },
        // params:
        //      matchId -> to be used as key in stored userVotes cookie
        //      matchVotes -> Array with votes. To be used as value for matchId key in userVotes cookie
        // returns:
        //      value of userVotes cookie
        updateMatchCookieVotes: (matchId, matchVotes) => {
            const cookieVotes = Vote.getCookieVotes();
            cookieVotes[matchId] = matchVotes;
            return cookieVotes;
        },
        // params:
        //      vote -> Vote selected by user (1, X etc)
        //      matchId -> match id that user has voted for
        // If voted same vote, vote is removed from match vote (un-vote)
        // return indexOf selected vote, for match
        // i.e. userVotes cookie: {1111: []} and user voted '2'
        //      new userVoted cookie will be {1111: ['2']} and will return 0
        userCookieVote: (vote, matchId) => {
            const voteCount = Vote.updateCookieVoteCount();
            if ((typeof DesktopGeneric !== 'undefined') && (voteCount === 3) || (voteCount === 100)) {
                Vote.timesAddShown += 1;
                DesktopGeneric.showAdModal();
            }
            let matchVotes = Vote.getCookieVotes()[matchId] || [];
            matchVotes = matchVotes.map(Vote.stringifyVotes);
            const hasVote = matchVotes.indexOf(vote) >= 0;
            matchVotes = Vote.clearVotes(matchVotes, Vote.voteGroups[vote]);
            if (!hasVote) {
                matchVotes.push(vote);
            }
            const cookieVotes = Vote.updateMatchCookieVotes(matchId, matchVotes);
            Vote.setCookieVotes(cookieVotes);
            return cookieVotes[matchId].map(Vote.stringifyVotes).indexOf(vote);
        },
        userAPIVote: (classRem, element, vote, matchId, voteButtons) => {
            const classAdd = classRem == 'btn-primary' ? 'btn-light' : 'btn-primary';
            element.removeClass('btn-light');
            element.addClass(classAdd);
            Ajax.vote(matchId, vote, function() {
                voteButtons.removeClass('hide_disabled').attr('disabled', false);
            });
        },
        init: () => {
            if (typeof Generic === 'undefined') {
                console.error('Generic is missing');
                return false;
            }

            if (!Generic.loggedin) {
                Vote.showCookieVotes();
            }

            $('.ii__votebut').off().click(function() {
                Vote.vote(
                    $(this).data('vote'),
                    $(this)
                );
            });
            return true;
        },
        vote: (vote, element) => {
            const classRem = element.hasClass('btn-primary') ? 'btn-primary' : 'btn-light',
                mid = element.attr('id').split(`bvote${ vote }`)[1],
                voteGroup = Vote.voteGroups[vote],
                voteButtons = $(`[id^=bvote][id$=${mid}]`);

            voteButtons.addClass('hide_disabled').attr('disabled', true);

            voteButtons.each(index => {
                const voteElem = $(voteButtons[index]);
                const thisVote = voteElem.attr('id').replace('bvote', '').replace(mid, ''),
                    thisVoteGroup = Vote.voteGroups[thisVote];
                if (thisVoteGroup === voteGroup) {
                    voteElem.removeClass('btn-primary');
                    voteElem.addClass('btn-light');
                }
            });

            if (!Generic.loggedin) {
                const voteActive = Vote.userCookieVote(`${vote}`, mid) >= 0;
                if (voteActive) {
                    element.removeClass('btn-light');
                    element.addClass('btn-primary');
                }
                voteButtons.removeClass('hide_disabled').attr('disabled', false);
            } else {
                Vote.userAPIVote(classRem, element, vote, mid, voteButtons);
            }
        }
    };
}();
